module.exports = __webpack_public_path__ + "img/2017pigc.9a1dce44.png";